"use client";

import { createContext, useContext, useState, ReactNode } from "react";
import type { MiniLesson } from "@/data/mini-lessons";

export interface Lesson {
  id: string;
  title: string;
  description: string;
  content?: any; // Full lesson content object from curriculum
  gradeLevel?: string;
  duration?: string;
  unit?: number;
  lessonNumber?: number;
  concepts?: string[];
  objectives?: string[];
  materials?: string[];
  socialEmotionalLearning?: string[];
  activities?: Array<{
    title: string;
    description: string;
    duration?: string;
  }>;
}

interface LessonContextType {
  currentLesson: Lesson | null;
  setCurrentLesson: (lesson: Lesson | null) => void;
  currentMiniLesson: MiniLesson | null;
  setCurrentMiniLesson: (lesson: MiniLesson | null) => void;
}

const LessonContext = createContext<LessonContextType | undefined>(undefined);

export function LessonProvider({ children }: { children: ReactNode }) {
  const [currentLesson, setCurrentLesson] = useState<Lesson | null>(null);
  const [currentMiniLesson, setCurrentMiniLesson] = useState<MiniLesson | null>(null);

  return (
    <LessonContext.Provider
      value={{
        currentLesson,
        setCurrentLesson,
        currentMiniLesson,
        setCurrentMiniLesson,
      }}
    >
      {children}
    </LessonContext.Provider>
  );
}

export function useLesson() {
  const context = useContext(LessonContext);
  if (context === undefined) {
    throw new Error("useLesson must be used within a LessonProvider");
  }
  return context;
}

